export default __webpack_public_path__ + "static/media/city.5bf0ddb2.png";